import React, { useState } from 'react';
import { doc, updateDoc } from 'firebase/firestore';
import { firestore } from '../config/firebase';

interface Props {
  teamId: string;
  boardId: string;
  initialStatuses: string[];
  onClose: () => void;
}

const options = ['active', 'archived'];

const StatusEditorPopover: React.FC<Props> = ({ teamId, boardId, initialStatuses, onClose }) => {
  const [statuses, setStatuses] = useState<string[]>(initialStatuses);
  const [saving, setSaving] = useState(false);

  const toggle = (status: string) => {
    setStatuses((prev) =>
      prev.includes(status) ? prev.filter((s) => s !== status) : [...prev, status]
    );
  };

  const handleSave = async () => {
    if (statuses.length === 0) return; // require at least one
    setSaving(true);
    const ref = doc(firestore, 'boards', teamId, 'brainstorming', boardId);
    await updateDoc(ref, { statuses });
    setSaving(false);
    onClose();
  };

  return (
    <div className="absolute right-2 top-8 z-50 bg-white shadow-lg rounded-md p-3 w-40 text-sm" onClick={(e)=>e.stopPropagation()}>
      <div className="space-y-2">
        {options.map((opt) => {
          const checked = statuses.includes(opt);
          return (
            <label key={opt} className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                className="form-checkbox h-4 w-4 text-blue-600"
                checked={checked}
                onChange={() => toggle(opt)}
              />
              {opt.charAt(0).toUpperCase() + opt.slice(1)}
            </label>
          );
        })}
      </div>
      <div className="flex justify-end gap-2 mt-3 text-xs">
        <button className="text-gray-600" onClick={onClose} disabled={saving}>
          Cancel
        </button>
        <button
          onClick={handleSave}
          disabled={saving || statuses.length === 0}
          className="px-2 py-1 bg-blue-600 text-white rounded disabled:opacity-50"
        >
          {saving ? 'Saving...' : 'Save'}
        </button>
      </div>
    </div>
  );
};

export default StatusEditorPopover; 